module.exports = __webpack_public_path__ + "media/check_animated.8a12bcd9.mp4";